import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface UseReferrerTrackerProps {
  referrerParam?: string;
  storageKey?: string;
}

const useReferrerTracker = ({
  referrerParam = 'referrer',
  storageKey = 'referrer'
}: UseReferrerTrackerProps = {}) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const referrerValue = searchParams.get(referrerParam);

    if (referrerValue) {
      // Save referrer to sessionStorage
      sessionStorage.setItem(storageKey, referrerValue);
      
      // Remove referrer parameter from URL
      searchParams.delete(referrerParam);
      const newSearch = searchParams.toString();
      const newUrl = newSearch 
        ? `${location.pathname}?${newSearch}`
        : location.pathname;

      navigate(newUrl, { replace: true });
    }
  }, [location.search, location.pathname, navigate, referrerParam, storageKey]);

  // Utility function to get the stored referrer
  const getStoredReferrer = (): string | null => {
    return sessionStorage.getItem(storageKey);
  };

  // Utility function to clear the stored referrer
  const clearReferrer = (): void => {
    sessionStorage.removeItem(storageKey);
  };

  return {
    getStoredReferrer,
    clearReferrer
  };
};

export default useReferrerTracker;